import React, { Component } from 'react';
import { Grid, Dropdown, Form, Button } from 'semantic-ui-react';
import BreadcrumbCustom from '../../layout/BreadcrumbCustom';
import ListAccounts from './ListAccounts';
import EnterPayments from './EnterPayments';
import { getInquiryAccountDetails, getAccountDetails } from '../../utils/rest';
import MessageBox from '../../ui/MessageBox';
import * as SimpleReactValidator from 'simple-react-validator';
import Loading from '../Loading';
const initialState = {
    acoAccountId: "",
    acoInvoiceId: "",
    conLastName: "",
    conFirstName: "",
    cltClientIds: []
}
class PaymentAdjustment extends Component {
    constructor(props) {
        super(props);
        this.validator = new SimpleReactValidator();
        this.state = {
            searchIndex: initialState,
            open: false,
            showPayment: false,
            data: {},
            searchItems: [],
            errorMessage: [],
            openError: false,
            loading: false,
            searchStateChanged: false
        };
    }
    componentDidMount() {
        this.props.addItem("helpFile", "pmt_enter-payments-adjustments.md");
        if (this.props.params && this.props.params.id > 0) {
            this.props.addItem("helpFile", "pmt_enter-payments-adjustments-entry.md");
            this.showPaymentInterface(this.props.params.id);
        }
    }

    componentWillUnmount() {
        this.props.addItem("helpFile", null);
    }

    close = () => {
        this.setState({
            open: false,
            openError: false
        })
    }

    showPaymentInterface = (acoAccountId) => {
        getAccountDetails(this.props.items.currentCorporate, acoAccountId).then((response) => {
            if (response !== null && response instanceof Object) {
                let data = [];
                data.push(response);
                this.setState({
                    open: false,
                    showPayment: true,
                    data: data
                });
                this.props.addItem("helpFile", "pmt_enter-payments-adjustments-entry.md");
            }
        })
    }

    showSearchInterface = () => {
        this.setState({
            open: false,
            showPayment: false,
            data: {}
        });
        this.props.addItem("helpFile", "pmt_enter-payments-adjustments.md");

    }
    
    handleChange = (e, evt) => {
        this.setState({
            searchStateChanged: true,
            searchIndex: {
                ...this.state.searchIndex,
                [evt.name]: evt.value
            }
        })
    }

    handleSubmit = (e) => {
        e.preventDefault();
        if (this.validator.allValid()) {
            this.setState({
                loading: true
            }, () => {
                if (this.state.searchStateChanged) {
                    getInquiryAccountDetails(this.props.items.currentCorporate, this.state.searchIndex).then((response) => {
                        if (response !== null && response instanceof Array) {
                            this.setState({
                                searchItems: response,
                                open: true,
                                loading: false,
                                searchStateChanged: false
                            })
                        }
                    }).then(() => {
                        this.setState({
                            loading: false
                        })
                    })
                } else {
                    this.setState({
                        open: true,
                        loading: false,
                        searchStateChanged: false
                    })
                }
            });
        } else {
            this.setState({
                errorMessage: this.props._errorItems(this.validator.fields),
                openError: true
            });
            this.forceUpdate();
        }
    }


    render() {
        if (this.state.showPayment) {
            return <EnterPayments data={this.state.data} showSearchInterface={this.showSearchInterface} {...this.props} />
        }
        return (
            <div>
                {this.state.loading ? <Loading /> : ""}
                <BreadcrumbCustom {...this.props} parent="Payments" child={[{ name: "Enter Payments & Adjustments", url: null }]} />
                <Grid className="g-bkgd">
                    <Grid.Row>
                        <Grid.Column>
                            <Form className="small">
                                <Form.Group>
                                    <Form.Field width={4} className="required">
                                        <label>Select Client ID(s):</label>
                                        <Dropdown placeholder='Select Client ID(s)' className="fluid" multiple search selection options={this.props.items.clients.map((client) => { client.disabled = !client.allowedtopostpayment; return client; })} name="cltClientIds" value={this.state.searchIndex.cltClientIds} onChange={this.handleChange}></Dropdown>
                                        {this.validator.message('Client ID(s)', this.state.searchIndex.cltClientIds, 'required')}
                                    </Form.Field>
                                    <Form.Field width={12}>
                                    </Form.Field>
                                </Form.Group>
                                <Form.Group>
                                    <Form.Field width={4}>
                                        <Form.Input label={this.props.t("client.account") + ":"} placeholder={this.props.t("client.account")} type="text" name="acoInvoiceId" value={this.state.searchIndex.acoInvoiceId} onChange={this.handleChange} />
                                    </Form.Field>
                                    <Form.Field width={4}>
                                        <Form.Input label={this.props.t("our.account") + ":"} placeholder={this.props.t("our.account")} type="text" name="acoAccountId" value={this.state.searchIndex.acoAccountId} onChange={this.handleChange} />
                                    </Form.Field>
                                    <Form.Field width={4}>
                                        <Form.Input label={this.props.t("consumer.name")} placeholder={this.props.t("consumer.name.placeholder")} type="text" name="conLastName" value={this.state.searchIndex.conLastName} onChange={this.handleChange} />
                                    </Form.Field>
                                    <Form.Field width={4}>
                                        <Button className="ui left floated small button push-down" onClick={this.handleSubmit}>Search for My Account</Button>
                                    </Form.Field>
                                </Form.Group>
                            </Form>
                            <ListAccounts accounts={this.state.searchItems} open={this.state.open} close={this.close} {...this.props} showPaymentInterface={this.showPaymentInterface} />
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
                <MessageBox size="mini" box={11} open={this.state.openError} close={this.close} required={this.state.errorMessage} {...this.props} />
            </div>
        );
    }
}
export default PaymentAdjustment;


// WEBPACK FOOTER //
// ./src/app/ui/payments/PaymentAdjustment.js